<div>
<h3 translate class="page-title text-center">RETURN_WARRANTY</h3>
<div class="row">
    @if (customerHasReachedDailyLimit) {
        <div class="col-11 text-right text-danger pt-1">
            <span translate>LIMIT_REACHED</span>
        </div>
    }
    <div [ngClass]="customerHasReachedDailyLimit ? 'col-1' : 'col-12'" class="text-right">
        <button type="button" class="btn btn-primary" [disabled]="customerHasReachedDailyLimit" (click)="openCreateModal()" translate>
            CREATE_NEW
        </button>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <lib-return-warranty-list></lib-return-warranty-list>
    </div>
</div>
</div>